import type React from 'react';

import { Layout } from './Layout';

/**
 * Page footer landmark
 */
export function PageFooter(props: { children: React.ReactNode } & React.ComponentProps<'footer'>) {
    const { children, ...rest } = props;
    return (
        <Layout>
            <footer {...rest} className="flex w-full flex-col gap-6 pb-6">
                {children}
            </footer>
        </Layout>
    );
}
